import { SegmentedControl } from 'components/display/SegmentedControl'

const ANY = 'any'
const MAX_HOURS = 4

const OPTIONS = [
  { value: '60', label: '1 hr' },
  { value: '120', label: '2 hrs' },
  { value: '180', label: '3 hrs' },
  { value: '240', label: '4 hrs' },
  { value: ANY, label: 'Any' },
]

const toOptionValue = (driveTime?: number | null): string =>
  driveTime ? String(Math.min(Math.ceil(driveTime / 60), MAX_HOURS) * 60) : ANY

const toDriveTime = (value: string): number | null =>
  value === ANY ? null : Number(value)

type DriveTimeFilterProps = {
  driveTime?: number | null
  onChange: (driveTime: number | null) => any
}

const DriveTimeFilter = ({ driveTime, onChange }: DriveTimeFilterProps) => (
  <SegmentedControl
    name="drive-time"
    ariaLabel="Maximum drive time"
    options={OPTIONS}
    value={toOptionValue(driveTime)}
    onChange={(value) => onChange(toDriveTime(value))}
  />
)

export default DriveTimeFilter
